<template lang="pug">
.icon-button(:class="`${largeIcon ? 'large-icon' : ''} ${text && !icon ? 'text' : ''}`" @click="!disabled ? $emit('clicked', true) : null")
  .icon-button-inner
    template(v-if="icon")
      i.mdi(:class="`mdi-${icon}`")
    template(v-else-if="text")
      | {{ text }}
</template>

<script>
export default {
  props: {
    largeIcon: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.icon-buttons-group {
  border-radius: 4px;
  display: flex;
  max-height: 34px;
  user-select: none;

  .icon-button {
    height: 30px;
    width: 30px;
    border: 0;
    border-radius: 0;
    border-right: 1px solid #B6BDC6;

    .icon-button-inner {
      border-radius: 0;
    }

    &:first-child {
      border-radius: 4px 0 0 4px;
      .icon-button-inner {
        border-radius: 4px 0 0 2px;
      }
    }

    &:last-child {
      border-left: 0;
      border-radius: 0 4px 4px 0;

      .icon-button-inner {
        border-radius: 0 4px 2px 0;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.icon-button {
  background-color: #E7EBEC;
  border: 1px solid #B6BDC6;
  border-radius: 4px;
  padding-bottom: 2px;
  display: inline-flex;
  height: 32px;
  width: 32px;

  &.text {
    width: auto;
    .icon-button-inner {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  &:hover {
    cursor: pointer;
  }

  .icon-button-inner {
    background-color: white;
    border-radius: 4px 4px 2px 2px;
    flex: 1;
    line-height: 30px;
    text-align: center;
  }

  i {
    font-size: 1rem;
  }

  &.large-icon {
    i {
      font-size: 1.5rem;
    }
  }

  &.padding-1-top {
    .icon-button-inner {
      padding-top: 1px;
    }
  }

  &.padding-1-bottom {
    .icon-button-inner {
      padding-bottom: 1px;
    }
  }

  &.blue {
    color: #0062FF;
  }

  &.red {
    color: #E10000;
  }

  &.gray {
    color: #E9EBED;
  }

  &.dark-gray {
    color: #858585;
  }
}
</style>
